import MainButton from '@/components/Buttons/MainButton';
import { cartState, cartStore } from '@/stores/cart.store';
import { ApiRequest } from '@/utils/axios';
import userStore from '@/stores/user.store';
import { notify } from '@/utils/notify';
import SuccessIcon from '@/components/Notifications/SuccessIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import React, { Dispatch, SetStateAction } from 'react';
import AlertIcon from '@/components/Notifications/AlertIcon';
import { modalStore } from '@/stores/modal.store';

interface Props {
    selectedItemIds: cartState['selectedItemIds'];
    load: () => void;
    setPage: Dispatch<SetStateAction<number>>;
    balance: number;
    total: number;
}

const MarketplaceFooter = ({ selectedItemIds, load, setPage, total, balance }: Props) => {
    const { clearCart } = cartStore((state) => state);
    const { fetchUser } = userStore((state) => state);
    const { close } = modalStore((state) => state);

    const disabled = total == 0 || total > balance || balance == 0;

    async function purchase() {
        clearCart();
        const itemIds = Array.from(selectedItemIds).map((id) => Number(id));
        if (disabled) {
            return notify(
                'error',
                <AlertIcon />,
                <NotifyWrapper title={'Error'} text={`Not enough balance`} />
            );
        }
        const {
            data: { success },
        }: { data: { success: boolean } } = await ApiRequest.post('/market/buy/balance', {
            itemIds,
        });

        if (success) {
            await fetchUser();
            load();
            setPage(1);
            close();
            notify(
                'success',
                <SuccessIcon />,
                <NotifyWrapper title={'Success'} text={`You successfully bought new skins`} />
            );
        }
    }

    return (
        <MainButton
            onClick={() => purchase()}
            disabled={disabled}
            background={disabled ? '#9D9D9D' : ''}
            className={`w-full text-white bg-blue`}
            text={'BUY'}
        />
    );
};

export default MarketplaceFooter;
